import {segment} from './helpers'

/**
 * Tracks errors from invalid sizes save attempt.
 *
 * @param {Array.<string>} [errors] errors surfaced from invalid size save attempt
 * @param {string|undefined} [flowName] name of the flow the user went through
 */
export const triedInvalidSizes = (errors, flowName) =>
  segment('Tried Invalid Sizes', {
    errors,
    flowName,
  })
